import { makeStyles } from "@material-ui/core/styles";
import { fontWeight, padding } from "@mui/system";

export default makeStyles({
  container: {
    padding: 70,
    ["@media (max-width:1200px)"]: {
      padding: 40,
    },
    ["@media (max-width:959px)"]: {
      padding: 20,
    },
    ["@media (max-width:559px)"]: {
      padding: 5,
      paddingTop: 20,
    },
  },
  searchbar: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    padding: 50,
    ["@media (max-width:1200px)"]: {
      padding: 40,
    },
    ["@media (max-width:959px)"]: {
      padding: 20,
    },
    ["@media (max-width:559px)"]: {
      padding: 5,
      paddingTop: 20,
    },
  },
  box: {
    display: "flex",

    flexDirection: "column",
    width: "100%",
    ["@media (max-width:959px)"]: {
      alignItems: "center",
    },
  },
  formFeild: {
    border: "none",
    height: 40,
    marginTop: 15,
    marginBottom: 20,
    padding: 10,
    paddingLeft: 16,
    color: "#547972",
    fontSize: 16,
    width: "80%",
    background: "#fefff0",
    borderRadius: 5,
    outline: "none",
    ["@media (max-width:559px)"]: {
      width: "86%",
    },
  },
  textFeild: {
    resize: "none",
    border: "none",
    height: 300,
    marginTop: 15,
    marginBottom: 20,
    padding: 10,
    paddingLeft: 16,
    color: "#547972",
    fontSize: 17,
    width: "80%",
    background: "#fefff0",
    borderRadius: 5,
    outline: "none",
    fontFamily: "ubuntu",
    lineHeight: 1.5,
    ["@media (max-width:559px)"]: {
      width: "86%",
    },
  },
  submitBtn: {
    border: "none",
    height: 50,
    marginTop: 15,
    marginBottom: 20,
    padding: 10,
    paddingLeft: 16,
    color: "#547972",
    fontSize: 16,
    width: "80%",
    background: "#fefff0",
    borderRadius: 5,
    outline: "none",

    "&:hover": {
      background: "#eaebdc",
    },

    ["@media (max-width:559px)"]: {
      width: "86%",
    },
  },
});
